import React from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import CircleInfoIcon from '../Icons/CircleInfoIcon.js';

var css_248z = ".uaBv1{align-items:center;color:#414141;display:flex;font-size:14px;justify-content:start;max-width:375px}[dir] .uaBv1{background-color:#f0f4f7;border-radius:10px;margin:0 auto;padding:8px}.uaBv1 svg{flex-shrink:1;height:100%;max-height:24px;max-width:24px;width:100%}[dir] .uaBv1 svg{margin:0 8px}[dir] .uaBv1 p{margin:0}";
var styles = {"genericError":"uaBv1"};
styleInject(css_248z);

const GenericError = ({ text, dataHook }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.genericError, "data-hook": dataHook }, /* @__PURE__ */ React.createElement(CircleInfoIcon, null), /* @__PURE__ */ React.createElement("div", null, text));
};

export { GenericError as default };
//# sourceMappingURL=GenericError.js.map
